import { useEffect, useState } from "react";
import { getSystemTicketState } from "utils/api";

export default function useSystemTicketState(soulId) {
  const [ticketState, setTicketState] = useState(null);
  const [hasPurchased, setHasPurchased] = useState(false);
  const [isLoading, setIsLoading] = useState(Boolean(soulId));
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let active = true;
    if (!soulId) {
      setIsLoading(false);
      return () => { active = false; };
    }

    const load = async () => {
      setIsLoading(true);
      setIsError(false);
      try {
        const data = await getSystemTicketState(soulId);
        if (!active) return;
        setTicketState(data);
        setHasPurchased(true);
      } catch (error) {
        if (!active) return;
        if (error.status === 404) {
          setTicketState(null);
          setHasPurchased(false);
        } else {
          setIsError(true);
        }
      } finally {
        if (active) setIsLoading(false);
      }
    };

    load();
    return () => { active = false; };
  }, [soulId]);

  return { ticketState, hasPurchased, isLoading, isError };
}
